/* eslint-disable no-unused-vars */
import React, {
  Component,
  useContext,
  useRef,
  useCallback,
  useEffect,
  useState,
} from 'react';
// import PropTypes from 'prop-types';
/* eslint-enable no-unused-vars */

import {
  StyledBox,
  StyledEmbeddedIcon,
  StyledEmbeddedTitle,
  StyledHeader,
  StyledMessage,
  StyledWrapper,
} from './style';

import actions from '../../../broadcast/actions/submit';
import { Broadcast, Init } from '../../../broadcast';
import sendRAT, { ACTION, SCREEN } from '../../../../phase2/survey/app/rat';

/**
 * 埋込み型 `Thanks`
 * @param {string} title title 文字列
 * @param {string} [message=''] title 下 message 文字列
 * @param {string} [className=''] option class name
 * @param {*} submit Redux.store.submit - submit 状態を保持します
 * @param {boolean} [generator=false] generator preview mount flag
 * @param {boolean} desktop - resize desktop flag
 * @param {*} state {@link survey}.Context.state
 * @return {boolean|*} React.node
 * @constructor
 */
const ThanksEmbedded = ({
  title,
  message = '',
  className = '',
  submit,
  generator = false,
  desktop,
  state,
}) => {
  const [show, setShow] = useState(generator);
  // 送信していないことを確認し RAT 実行します
  const sendRat = useCallback(() => {
    if (!submit.meta.thanks) {
      // console.log('ThanksEmbedded - ACTION.APPEAR', ACTION.APPEAR, submit.meta)
      // ---
      Broadcast.submit.thanks();
      // RAT - thankyou appear
      sendRAT({
        cId: state.config.cId.value,
        screen: SCREEN.THANKYOU,
        action: ACTION.APPEAR,
      });
    }
  }, [state, submit]);

  useEffect(() => {
    // console.log('ThanksEmbedded > useEffect - submit / actions', submit, actions)
    if (submit && submit.type === actions.type.COMPLETE) {
      Init.submit();
      setShow(true);
      // ---
      // appear
      sendRat();
      // ---
    }
  }, [submit, setShow, sendRat]);
  // console.log('ThanksEmbedded - show', show, submit)
  return (
    show && (
      <StyledWrapper className={`show-${String(show)}`} desktop={desktop}>
        <StyledBox className={`ThanksEmbedded ${className}`}>
          <StyledHeader>
            <StyledEmbeddedIcon />
            <StyledEmbeddedTitle>{title}</StyledEmbeddedTitle>
          </StyledHeader>
          <StyledMessage>{message}</StyledMessage>
        </StyledBox>
      </StyledWrapper>
    )
  );
};

export default ThanksEmbedded;



// WEBPACK FOOTER //
// ./src/embedded-type/survey/page/thanks/ThanksEmbedded.js